
import { createSlice } from '@reduxjs/toolkit';
import { getProvinces, getCities, getWaySells, getPriceVariants, getCategories, postSupplier } from '../../api/API';

export const registerSupplierSlice = createSlice({
    name: 'registerSupplier',
    initialState: {
        provinces: [],
        cities: [],
        waySells: [],
        priceVariants: [],
        categories: []     
    },
    reducers: {
        setProvinces: (state, action) => {
            state.provinces = action.payload;
        },
        setCities: (state, action) => {
            state.cities = action.payload;
        },
        setWaySells: (state, action) => {
            state.waySells = action.payload;
        },
        setPriceVariants: (state, action) => {
            state.priceVariants = action.payload;
        },
        setCategories: (state, action) => {
            state.categories = action.payload;
        }
    },
});

export const { 
    setCities, 
    setProvinces, 
    setWaySells, 
    setPriceVariants, 
    setCategories } = registerSupplierSlice.actions;

export const loadProvinces = () => async (dispatch) => {
    getProvinces().then((provinces) => {
        dispatch(setProvinces(provinces));
    });
}

export const selectProvincesDropdown = state => {
    return state.registerSupplier.provinces.map(({identifier_id, name}) => {
        return {label: name, value: identifier_id};
    });
}

export const loadCities = (provinceId) => async (dispatch) => {
    setCities([]);
    getCities(provinceId).then((cities) => {
        setCities([]);
        dispatch(setCities(cities));
    });
}

export const selectCitiesDropdown = state => {
    return state.registerSupplier.cities.map(({id, name}) => {
        return {label: name, value: id};
    });
}

export const loadWaySells = () => async (dispatch) => {
    getWaySells().then((waySells) => {
        dispatch(setWaySells(waySells));
    });
}

export const selectWaySells = function (state) {
    return state.registerSupplier.waySells;
}

export const loadPriceVariants = () => async (dispatch) => {
    getPriceVariants().then((priceVariants) => {
        dispatch(setPriceVariants(priceVariants));
    });
}

export const selectPriceVariants = function (state) {
    return state.registerSupplier.priceVariants;
}

export const loadCategories = () => async (dispatch) => {
    getCategories().then((categories) => {
        dispatch(setCategories(categories));
    });
}

export const selectCategories = function (state) {
    return state.registerSupplier.categories;
}

export const addSupplier = ({ name, email, whatsapp_number, website, facebook, 
    tokopedia, instagram, shopee, is_dropship, is_catalog, description, price_variants, 
    supplier_type, way_sells, city, category}, 
    setIsLoadingFunc, showNotificationMessageFunc) => async () => {    
        postSupplier({ name, email, whatsapp_number, website, facebook, 
            tokopedia, instagram, shopee, is_dropship, is_catalog, description, 
            price_variants, supplier_type, way_sells, city, category }).then(() => {
        showNotificationMessageFunc("Pendaftaran berhasil! Customer service kami akan segera menghubungi Anda", "success");
    }).catch((error) => {
        const response = error.response;
        if (response == null) {
            showNotificationMessageFunc("Pendaftaran gagal. Mohon coba kembali", "danger");
            return;
        } else {
            showNotificationMessageFunc(error.message, "danger");
        }
    }).then(() => { setIsLoadingFunc(false); });
}


export default registerSupplierSlice.reducer;
